interface FilterBarProps {
  searchValue: string;
  onSearch: (val: string) => void;
  activeRegion: string;
  onRegionChange: (val: string) => void;
  activeCategory: string;
  onCategoryChange: (val: string) => void;
  sortBy: "default" | "price-asc" | "price-desc" | "profit";
  onSortChange: (val: "default" | "price-asc" | "price-desc" | "profit") => void;
  categories: string[];
  totalCount: number;
}

export default function FilterBar({
  searchValue,
  onSearch,
  activeRegion,
  onRegionChange,
  activeCategory,
  onCategoryChange,
  sortBy,
  onSortChange,
  categories,
  totalCount,
}: FilterBarProps) {
  const regions = [
    { key: "全部商品", label: "全部貨源", icon: "ri-apps-line" },
    { key: "體驗認購區", label: "體驗認購區", icon: "ri-fire-line" },
    { key: "VIP認購區", label: "VIP認購區", icon: "ri-vip-crown-line" },
    { key: "吉時好物", label: "吉時好物", icon: "ri-gift-line" },
  ];

  return (
    <div className="space-y-4">
      {/* Search + Sort */}
      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
        <div className="relative flex-1">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
            <i className="ri-search-line text-sm text-gray-400"></i>
          </div>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="搜尋商品名稱、品類或標籤..."
            className="w-full pl-9 pr-4 py-2.5 rounded-lg text-sm bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 outline-none focus:border-amber-400 focus:bg-white transition-colors"
          />
          {searchValue && (
            <button
              onClick={() => onSearch("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center cursor-pointer"
            >
              <i className="ri-close-line text-sm text-gray-400"></i>
            </button>
          )}
        </div>
        <select
          value={sortBy}
          onChange={(e) =>
            onSortChange(e.target.value as "default" | "price-asc" | "price-desc" | "profit")
          }
          className="px-3 py-2.5 rounded-lg text-sm bg-gray-50 border border-gray-200 text-gray-700 outline-none focus:border-amber-400 cursor-pointer"
        >
          <option value="default">默認排序</option>
          <option value="price-asc">認購價低到高</option>
          <option value="price-desc">認購價高到低</option>
          <option value="profit">利潤最高</option>
        </select>
      </div>

      {/* Region big tabs */}
      <div className="flex flex-wrap gap-2">
        {regions.map((r) => (
          <button
            key={r.key}
            onClick={() => {
              onRegionChange(r.key);
              onCategoryChange("");
            }}
            className={`flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
              activeRegion === r.key
                ? "bg-amber-500 text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className={`${r.icon} text-xs`}></i>
            </div>
            {r.label}
          </button>
        ))}
      </div>

      {/* Category chips — only show sub-categories under current region */}
      {categories.length > 0 && (
        <div className="flex flex-wrap gap-2 items-center">
          <span className="text-xs text-gray-400 whitespace-nowrap">品類：</span>
          <button
            onClick={() => onCategoryChange("")}
            className={`px-3 py-1 rounded-full text-xs font-medium transition-all cursor-pointer ${
              activeCategory === ""
                ? "bg-stone-800 text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => onCategoryChange(cat === activeCategory ? "" : cat)}
              className={`px-3 py-1 rounded-full text-xs font-medium transition-all cursor-pointer ${
                activeCategory === cat
                  ? "bg-stone-800 text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              {cat}
            </button>
          ))}
          <span className="text-xs text-gray-400 ml-auto">共 {totalCount} 件商品</span>
        </div>
      )}
    </div>
  );
}
